<div class="news-container p-4 fade-in-el">
  <!-- Back Action -->
  <div class="mb-4">
    <a id="news-back-button" class="btn btn-dark back-btn text-decoration-none" [routerLink]="['/home/overview']">
      <i class="bi bi-arrow-left"></i> Back to Overview
    </a>
  </div>

  @if (article(); as item) {
  <!-- Hero Banner Section -->
  <header class="news-hero" [style.background-image]="'url(' + item.image + ')'">
    <div class="news-hero-overlay">
      <span class="badge rounded-pill mb-2 align-self-start py-2 px-3 fw-bold text-uppercase"
        [ngClass]="getCategoryClass(item.category)">
        {{ item.category }}
      </span>
      <h2 class="fw-bold text-white mb-2 display-6">{{ item.title }}</h2>
      <div class="d-flex align-items-center gap-3 text-white text-opacity-75 small">
        @if (item.author) {
        <span><i class="bi bi-person-fill me-1"></i> {{ item.author }}</span>
        }
        <span><i class="bi bi-clock me-1"></i> {{ item.timestamp }}</span>
      </div>
    </div>
  </header>

  <div class="row g-4">
    <!-- Main Content Column -->
    <main class="col-12 col-lg-8">
      <article class="news-body-card">
        <section [innerHTML]="item.content"></section>

        <!-- Interactive elements / Call to actions -->
        @if (item.id === 'spades-released') {
        <div id="spades-callout-banner"
          class="spades-callout mt-4 p-4 rounded-3 d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
          <div>
            <h5 class="fw-bold mb-1"><i class="bi bi-suit-spades-fill me-2 text-success"></i>Ready to play?</h5>
            <p class="mb-0 text-muted small">Join a Spades lobby and challenge real players right now!</p>
          </div>
          <button id="btn-play-spades-news" class="btn btn-spades-play px-4 py-2" [routerLink]="['/home/overview']">
            Discover Lobbies
          </button>
        </div>
        }

        <!-- Screenshots Gallery -->
        @if (item.gallery && item.gallery.length > 0) {
        <section class="news-gallery-section mt-5 pt-4 border-top border-secondary border-opacity-25">
          <h5 class="text-white fw-bold mb-3"><i class="bi bi-images me-2 text-success"></i>Screenshots</h5>
          <div class="row row-cols-2 row-cols-md-3 g-3">
            @for (img of item.gallery; track img; let idx = $index) {
            <div class="col">
              <div [id]="'spades-gallery-thumb-' + idx" class="gallery-thumbnail-wrapper" (click)="openLightbox(idx)">
                <img [src]="img" class="img-fluid rounded gallery-thumbnail" [alt]="item.title + ' screenshot ' + (idx + 1)">
                <div class="gallery-thumbnail-overlay">
                  <i class="bi bi-zoom-in fs-4"></i>
                </div>
              </div>
            </div>
            }
          </div>
        </section>
        }
      </article>
    </main>

    <!-- Sidebar Column -->
    <aside class="col-12 col-lg-4">
      <div class="news-sidebar-card p-4 rounded-3">
        <h5 class="text-uppercase fw-bold text-muted mb-4 letter-spacing-1">Recent Announcements</h5>

        <div class="d-flex flex-column gap-3">
          @for (recent of recentArticles(); track recent.id) {
          <a [id]="'recent-news-card-' + recent.id" class="recent-news-card text-decoration-none"
            [routerLink]="['/home/news', recent.id]">
            <div class="recent-thumb">
              <img [src]="recent.image" [alt]="recent.title">
            </div>
            <div class="recent-info">
              <span class="badge rounded-pill mb-1 align-self-start small-badge"
                [ngClass]="getCategoryClass(recent.category)">
                {{ recent.category }}
              </span>
              <h6 class="fw-bold mb-1 text-truncate text-white" style="max-width: 180px;">{{ recent.title }}</h6>
              <small class="text-muted"><i class="bi bi-clock me-1"></i> {{ recent.timestamp }}</small>
            </div>
          </a>
          } @empty {
          <div class="text-muted small text-center py-4">No other recent articles.</div>
          }
        </div>
      </div>
    </aside>
  </div>

  <!-- Lightbox Modal -->
  @if (lightboxOpen()) {
  <div id="news-image-lightbox" class="lightbox-overlay" (click)="closeLightbox()">
    <div class="lightbox-container" (click)="$event.stopPropagation()">
      <!-- Close button in the top right of the container -->
      <button id="lightbox-close-btn" class="btn lightbox-close" (click)="closeLightbox()" aria-label="Close Lightbox">
        <i class="bi bi-x-lg"></i>
      </button>

      <!-- Image Content -->
      <div class="lightbox-content-wrapper">
        <img [src]="activeImage()" class="lightbox-image img-fluid" alt="Enlarged screenshot">
      </div>

      <!-- Prev/Next Controls -->
      @if (article()?.gallery && article()!.gallery!.length > 1) {
      <button class="lightbox-nav prev" (click)="prevImage()" aria-label="Previous image">
        <i class="bi bi-chevron-left"></i>
      </button>
      <button class="lightbox-nav next" (click)="nextImage()" aria-label="Next image">
        <i class="bi bi-chevron-right"></i>
      </button>
      }
    </div>
  </div>
  }
  }
</div>